export const mutations = {
  UPDATE_CALCULATOR (state, payload) {
    state.calculator = payload;
  },
  UPDATE_CALCULATION_RESULT (state, payload) {
      state.calculationResult = payload;
  },
};
